import { render, staticRenderFns } from "./TableMain.vue?vue&type=template&id=265508cc"
import script from "./TableMain.vue?vue&type=script&lang=js"
export * from "./TableMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('265508cc')) {
      api.createRecord('265508cc', component.options)
    } else {
      api.reload('265508cc', component.options)
    }
    module.hot.accept("./TableMain.vue?vue&type=template&id=265508cc", function () {
      api.rerender('265508cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/History/TableMain.vue"
export default component.exports